import React, { useState, useEffect } from 'react';
import './DashboardHome.css';
import InfoCard from '../../DashboardComponents/InfoCard/InfoCard';
import AreaChartCard from '../../DashboardComponents/AreaChartCard/AreaChartCard';

export default function DashboardHome({data}) {
    const [areaChartData, setAreaChartData] = useState({
        series: [
            {
                name: "",  // Series for Projects
                // data: [1,2,3,4,5,6,7,8,9,10,11,12],
                data: [],
            },
            {
                name: "",  // Series for Users
                // data: [3,6,9,12,15,18,21,24,27,30,33,36],
                data: [],
            }
        ],
        // categories: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        categories: [],
    });

    useEffect(() => {
        
        if (data && data.projectsAndUsersCombinedData) {
            const { month_year_launched, total_projects, total_users } = data.projectsAndUsersCombinedData;
            // Prepare the data for the area chart
            setAreaChartData({
                series: [
                    {
                        name: "Projects",
                        data: Object.values(total_projects),  // Extract total_projects as an array
                    },
                    {
                        name: "Users",
                        data: Object.values(total_users),  // Extract total_users as an array
                    }
                ],
                categories: Object.values(month_year_launched),  // Extract months as categories
            });
        }
    }, [data]); 
    
    return (
        <div>
            <div className='homerow1'>
                <InfoCard cardLabel={'Total Number of Projects'} cardCount={data?.totalNumberOfProjects}/>
                <InfoCard cardLabel={'Total Number of Users'} cardCount={data?.totalNumberOfUsers}/>
                <InfoCard cardLabel={'Most Liked Project'} clickableProject={data?.mostLikedProject?.project} cardCount={data?.mostLikedProject?.likes} cardDetails={'like'}/>
                <InfoCard cardLabel={'Most Popular Project Tag'} clickableTag={data?.mostPopularProjectTag.tag} cardCount={data?.mostPopularProjectTag?.count} cardDetails={'project'}/>
            </div>
            <div className='homerow2'>
                <AreaChartCard areaChartData={areaChartData}/>
            </div>
        </div>
    );
}